import { ImageProps } from "../../interface";
import classNames from "classnames";

import classes from "./image.module.scss";

const Image = (props: ImageProps) => {
    const { url, srcset, sizes, isAboveFold, aspectRatio, alt } = props;

    if (url === undefined) return null;

    const showcaption = props.showcaption || false;
    const type = props.type || "image";
    const loading = props.loading === "lazy" ? "lazy" : "eager";
    const description = props.description?.length ? props.description : null;
    const credit = props.credit?.length ? `(${props.credit})` : null;
    const mass = props.mass || "full";
    const additionalClasses = props.classNames;

    const sourceSet = srcset && srcset.length ? srcset.join(",") : undefined;
    const sizesStr = sizes && sizes.length ? sizes.join(",") : undefined;
    const style =
        typeof aspectRatio === "number"
            ? { aspectRatio: `${aspectRatio}` }
            : {};
    const fetchPriorityAttribute = isAboveFold ? { fetchpriority: "high" } : {};

    const cx = classNames.bind(classes);
    const imageClasses = cx(classes.imageMedia, type, mass, additionalClasses);

    const shouldShowCaption =
        showcaption && (description !== null || credit !== null);

    return (
        <figure className={imageClasses} data-testid="image-figure">
            <div className={classes.placeholder}>
                <img
                    loading={loading}
                    alt={alt || ""}
                    srcSet={sourceSet}
                    sizes={sizesStr}
                    src={url}
                    style={style}
                    data-testid="image-img"
                    data-cy={`${type || ""}-img`}
                    {...fetchPriorityAttribute}
                />
            </div>
            {shouldShowCaption && (
                <figcaption
                    className={"image-caption"}
                    data-testid="image-figcaption"
                >
                    {description} {credit}
                </figcaption>
            )}
        </figure>
    );
};

export default Image;
